import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-flex tw-h-[fit-content]" }
const _hoisted_2 = ["onMouseover"]
const _hoisted_3 = ["src", "alt"]

import { IUserProfileImage } from "@/interfaces/userInterfaces";
import { PropType } from "vue";
import GlobalAvatar from "@/components/common/globalAvatar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'avatarStack',
  props: {
  avatars: { type: Array as PropType<IUserProfileImage[]>, default: () => [] },
  maxShown: { type: Number, default: 2 },
},
  emits: ["on:hover"],
  setup(__props, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...__props.avatars].splice(0, __props.maxShown), (avatar, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: index,
        class: _normalizeClass(`tw-border-[0.938px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-[468.75px] tw-w-[32px] tw-inline-block tw-aspect-square tw-overflow-hidden tw-ml-[-4px]`),
        onMouseover: ($event: any) => (emit('on:hover', avatar)),
        onMouseout: _cache[0] || (_cache[0] = ($event: any) => (emit('on:hover', {})))
      }, [
        (avatar.file)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: avatar.file ? `data:image/png;base64,${avatar.file}` : '',
              alt: `avatar${index + 1}`,
              class: "tw-w-full tw-h-full"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (avatar.file === null)
          ? (_openBlock(), _createBlock(GlobalAvatar, {
              key: 1,
              class: "tw-cursor-pointer",
              name: avatar?.userName,
              "class-name": 'user-icon'
            }, null, 8, ["name"]))
          : _createCommentVNode("", true)
      ], 40, _hoisted_2))
    }), 128))
  ]))
}
}

})